<template>
    <div class="wrap wrap--min wrap--last">
        <SectionTitle text="Company" class="title" />

        <div class="container">
            <!-- 会社概要 -->
            <div class="row">
                <h2 class="h2">会社概要</h2>
                <dl>
                    <dt>株式会社ロデオブロス</dt>
                    <dd>〒121-0075 東京都足立区一ツ家2-3-3</dd>
                    <dd>TEL：03-5856-5858</dd>
                    <dd>FAX：03-5856-5858</dd>
                    <dd>店舗運営責任者：三原 秀晃(通信販売部)</dd>
                    <dd>店舗セキュリティ責任者：三原 秀晃</dd>
                    <dd>実店舗営業時間：11:00 ～ 18:00</dd>
                    <dd>電話受付時間：12:00 ～ 14:00</dd>
                    <dd>定休日：日曜日・第3土曜日/夏季・年末年始休業</dd>

                    <dd v-if="['R1', 'R2', 'O'].includes($store.state.hostName)">店舗連絡先：<a href="mailto:rodeo@aun-wa.com">rodeo@aun-wa.com</a></dd>
                    <dd v-else-if="['Y1', 'Y2'].includes($store.state.hostName)">店舗連絡先：<a href="mailto:rodeobros@aun-wa.com">rodeobros@aun-wa.com</a></dd>

                    <dd>店舗連絡先：<a href="mailto:henpin-koukan@aun-wa.com">henpin-koukan@aun-wa.com</a></dd>
                </dl>

                <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3236.707836905831!2d139.8115085!3d35.7825525!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601891d37944aa81%3A0x2b11de25bf1d55fc!2zUk9ERU8gQlJPUyDjg63jg4fjgqrjg5bjg63jgrk!5e0!3m2!1sen!2sjp!4v1444093837578" width="100%" height="400px" frameborder="0" style="border:0" allowfullscreen=""></iframe>
            </div>

            <!-- 送料について -->
            <div class="row" v-if="['R1', 'R2'].includes($store.state.hostName)">
                <h2 class="h2">送料について</h2>
                <p>
                    <b><a style="color: #0000FF" href="https://event.rakuten.co.jp/guide/freeshippingline/?l-id=item_pc_fsl_guide">送料無料ライン対応ショップ「39(サンキュー)ショップ」</a>
                    <br>39(サンキュー)ショップとは、送料無料ラインを3,980円以下（※特定商品、一部地域を除く）に設定しているショップの総称となります。</b>
                    <br>
                    <br><b>沖縄県へお届け希望のお客様</b>
                    <br>沖縄県へのお届けは別途地域料1,500円（税込1,650円）を頂戴いたします。
                    <br>沖縄県のお客様は、合計税込9,800円以上お買い上げの場合、送料無料となります。
                    <br>沖縄県、その他離島への発送は佐川急便をお選びいただいた場合でも、ヤマト運輸での発送となります。ご理解・ご了承下さい。
                    <br>送料につきましては、カート内で表示されません。
                    <br>送料を含めたお支払総額を「ご注文確定メール」でお知らせいたしますで、必ずご確認ください。
                </p>
            </div>

            <div class="row" v-else-if="['Y1', 'Y2', 'O'].includes($store.state.hostName)">
                <h2 class="h2">送料について</h2>
                <p>
                    <b>10,000円（税抜）以上お買い上げで送料無料（当店負担）にて発送いたします。<br>商品代金10,000円（税抜）未満の場合、送料一律540円（税込）を頂戴しております。</b>
                    <br>
                    <br><b>沖縄県へお届け希望のお客様</b>
                    <br>沖縄県へのお届けは別途地域料1,500円（税込1,650円）を頂戴いたします。
                    <br>沖縄県のお客様は、合計税込22,000円以上お買い上げの場合、送料無料となります。
                    <br>沖縄県、その他離島への発送は佐川急便をお選びいただいた場合でも、ヤマト運輸での発送となります。ご理解・ご了承下さい。
                    <br>送料につきましては、カート内で表示されません。
                    <br>送料を含めたお支払総額を「ご注文確定メール」でお知らせいたしますで、必ずご確認ください。
                </p>
            </div>

            <!-- あす楽について -->
            <div class="row" v-if="['R1', 'R2'].includes($store.state.hostName)">
                <h2 class="h2">あす楽について</h2>
                <p>
                    <b>休業日（定休日、夏季休業、年末年始休業）や天災などによる予期せぬ休業を除き対応いたします。</b>
                    <br><img src="@/assets/asuraku.gif" style="width:100px; margin:10px 0px">
                    <br>下記該当の場合、あす楽が対応できない場合がございます。
                    <br>商品の傷 / 売り違い / 休業日（定休日、夏季休業、年末年始休業）や予期せぬ休業など / 運送会社・天候交通情報など各種の事情による遅延 / 離島、あす楽対象外商品との同梱
                </p>
            </div>

            <!-- あすつくについて -->
            <div class="row" v-else-if="['Y1', 'Y2'].includes($store.state.hostName)">
                <h2 class="h2">あすつくについて</h2>
                <p>
                    <b>休業日（定休日、夏季休業、年末年始休業）や天災などによる予期せぬ休業を除き対応いたします。</b>
                    <br>下記該当の場合、あすつくが対応できない場合がございます。
                    <br>商品の傷 / 売り違い / 休業日（定休日、夏季休業、年末年始休業）や予期せぬ休業など / 運送会社・天候交通情報など各種の事情による遅延 / 離島、あすつく対象外商品との同梱
                </p>
            </div>

            <!-- お支払について -->
            <div class="row" v-if="['R1'].includes($store.state.hostName)">
                <h2 class="h2">お支払について</h2>
                <p><b><a style="color: #0000FF" href="https://www.rakuten.co.jp/auc-rodeo/info2.html">詳しくは決済・配送方法案内ページをご覧下さいませ。</a></b></p>
            </div>

            <div class="row" v-else-if="['R2'].includes($store.state.hostName)">
                <h2 class="h2">お支払について</h2>
                <p><b><a style="color: #0000FF" href="https://www.rakuten.co.jp/rodeo-2nd/info2.html">詳しくは決済・配送方法案内ページをご覧下さいませ。</a></b></p>
            </div>

            <div class="row" v-else-if="['Y1'].includes($store.state.hostName)">
                <h2 class="h2">お支払について</h2>
                <p><b><a style="color: #0000FF" href="https://store.shopping.yahoo.co.jp/rodeobros/guide.html">詳しくはお買い物ガイドページをご覧下さいませ。</a></b></p>
            </div>

            <div class="row" v-else-if="['Y2'].includes($store.state.hostName)">
                <h2 class="h2">お支払について</h2>
                <p><b><a style="color: #0000FF" href="https://store.shopping.yahoo.co.jp/bros/guide.html">詳しくはお買い物ガイドページをご覧下さいませ。</a></b></p>
            </div>

            <div class="row" v-else-if="['O'].includes($store.state.hostName)">
                <h2 class="h2">お支払について</h2>
                <p><b>クレジットカード</b>
                    <br><img src="@/assets/info-card.png" style="width:300px; margin:10px 0px">
                    <br>当店でご利用いただけるクレジットカードは、VISA・Master・JCB・AMEX・Diners、すべてのカード会社で、一括払いが可能となっております。
                    <br>※カードブランドによって、ご利用可能お支払い回数が異なりますのでご注意ください。
                    <br>
                    <br>【 VISA・Master・JCBのお支払い区分 】
                    <br>リボ、分割（3・5・6・10・12・15・18・20・24回が可能です。）
                    <br>ボーナス一括（夏 [ 8月払い：12月16日～6月15日 ]、冬 [ 翌年1月払い：7月16日～11月15日 ]）
                    <br>
                    <br>【 AMEX・Dinersのお支払い区分 】
                    <br>ボーナス一括（夏 [ 8月払い：12月16日～6月15日 ]、冬 [ 翌年1月払い：7月16日～11月15日 ]）
                    <br>
                    <br>【 備考 】
                    <br>クレジットカード決済では、SSL というシステムを利用しております。
                    <br>カード番号は暗号化されて送信されますので、安心してご利用ください。
                    <br>
                    <br>なお、当カード決済システム上、クレジットカードのご利用控えは発行しておりません。
                    <br>カード会社より送付されるご利用明細をご確認ください。
                    <br>
                    <br>※お客様のご利用状況等により、他の決済方法へ変更をお願いする場合がございます。
                </p>

                <hr>

                <p><b>代金引換</b>
                    <br>【 支払い方法 】
                    <br>現金 / クレジットカード / 電子マネー(nanaco、Edy、WAON)
                    <br><img src="@/assets/info-price.jpg" style="width:200px; margin:10px 0px">
                    <br>【 業者 】
                    <br>ヤマト運輸 / 佐川急便（ご希望の方は備考欄にご記載お願いいたします。）
                    <br>
                    <br>【 備考 】
                    <br>お支払総額は、以下の通りです。
                    <br>
                    <br>商品代金：商品代金合計 ＋ 送料 ＋ 代引手数料
                    <br>代引手数料：全国一律料金：330円
                </p>

                <hr>

                <p><b>振込決済（前払い）</b>
                    <br>振込にかかわる金融機関の手数料はお客様のご負担となります。
                    <br>ご注文後、5日以内にご都合のよい金融機関より下記振込先にお振込ください。
                    <br>入金確認後の出荷となります。
                    <br>
                    <br>【 ご注意 】
                    <br>お振込みが確認できずご注文がキャンセルとなった場合、
                    <br>次回以降のお取引を停止させていただく場合がございます。
                    <br>あらかじめご了承くださいますようお願い申し上げます。
                    <br>
                    <br>お振込み期限は、ご注文確定メール送信日より5日間となっております。
                    <br>期限を過ぎますと自動的にキャンセル処理となりますので、ご注意ください。
                    <br>※ご事情によりお振込みが難しい場合は、お早めにご連絡ください。
                    <br>
                    <br>ご入金の確認は、ご注文者様のお名前にて行っております。
                    <br>ご注文者様と異なる名義でお振込みされる場合は、事前に当店までご連絡くださいますようお願いいたします。
                    <br>
                    <br>なお、消費税の端数は切り捨てにて計算しております。
                    <br>後ほど当店よりお送りするメールをご確認のうえ、お手続きをお願いいたします。
                </p>

                <hr>

                <p><b>銀行振込</b>
                    <br><img src="@/assets/ufj.png" style="width:250px; margin:10px 0px">
                    <br>【 振込先 】
                    <br>三菱UFJ銀行亀有支店 普通 1879955 カ）ロデオブロス
                    <br>
                    <br>【 備考 】
                    <br>お支払総額は、以下の通りです。
                    <br>
                    <br>商品代金：商品代金合計 ＋ 送料
                    <br>振込手数料：お振込時にお確かめください。
                </p>

                <hr>

                <p><b>郵便振替</b>
                    <br><img src="@/assets/yucho.png" style="width:250px; margin:10px 0px">
                    <br>【 振込先 】
                    <br>ゆうちょ銀行 10150-98472681
                    <br>【 口座名義 】
                    <br>カ）ロデオブロス
                    <br>
                    <br>【 店名 】
                    <br>〇一八(ゼロイチハチ)
                    <br>【 店番 】
                    <br>018
                    <br>【 預金種目 】
                    <br>普通預金
                    <br>【 口座番号 】
                    <br>9847268
                    <br>
                    <br>【 備考 】
                    <br>お支払総額は、以下の通りです。
                    <br>
                    <br>商品代金：商品代金合計 ＋ 送料
                    <br>振替手数料：郵便振替時にお確かめください。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">領収書について</h2>
                <p>弊社では、領収書の発行を承っております。
                    <br>領収書をご希望のお客様は、ご注文時に備考欄へご記載くださいますようお願いいたします。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">配送について</h2>
                <p><b>宅配便</b>
                    <br><img src="@/assets/info-ship.jpg" style="width:250px; margin:10px 0px">
                    <br>【 業者 】
                    <br>ヤマト運輸 / 佐川急便
                    <br>
                    <br>【 備考 】
                    <br>■ 銀行振込 / 郵便振替
                    <br>入金確認後の出荷となります。
                    <br>
                    <br>■ クレジット払い / 代金引換
                    <br>・お届け日指定なしの場合
                    <br>在庫がある商品につきましては、最短のお届け日で出荷の手配をさせていただきます。
                    <br>・お届け日指定ありの場合
                    <br>あらかじめご指定いただいた、お届け日に届くよう出荷の手配をさせていただきます。
                    <br>(商品の在庫状況等によりご希望に添えない場合もございます。)
                    <br>
                    <br>■ 在庫がない場合
                    <br>万が一、ご注文いただいた商品の在庫がない場合は、その旨をメールにてご連絡後、ご注文をキャンセルさせていただき、在庫があるもののみでお届けさせていただきます。
                    <br>メーカーに在庫がある場合は早急に取り寄せさせていただきます。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">日時指定について</h2>
                <p>時間指定は、以下のとおりとなっております。
                    <br>
                    <br>午前中（9時から12時）
                    <br>14時から16時
                    <br>16時から18時
                    <br>18時から20時
                    <br>19時から21時
                    <br>
                    <br>【 お届け時間の目安 】
                    <br>ご注文の2日以上あとの日にちをご指定ください。
                    <br>交通事情など、お客様のご都合にそえない場合もございます。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">返品・交換について</h2>
                <p>商品の品質については万全を期しておりますが、万一商品が破損・汚損していた場合、またはご注文と異なる場合は、お届け後5日間以内にご連絡下さい。
                    <br>すぐに返品・交換をさせていただきます。
                    <br>商品の返品・交換につきましてのご連絡は商品到着日より5日以内にご連絡下さい。
                    <br>また、返品・交換の発送はご連絡いただきました2日以内にご発送下さい。
                    <br>お客様ご都合による商品の返品・交換につきましては下記をご参照・ご理解の上、宜しくお願いいたします。
                    <br>
                    <br><b>【 ご返品・交換をお受けできない場合 】</b>
                    <br>お届け後6日以上経過した商品
                    <br>ご連絡いただいてから2日以内発送されていない場合
                    <br>お取り置き後のお届け商品
                    <br>お取り寄せ商品
                    <br>お客様が一度ご使用になられた商品、またはその形跡がある場合
                    <br>(お試しで着用されたくらいであれば交換可能です)
                    <br>お客様が汚損、破損された商品
                    <br>商品タグ・商品の箱・説明書等を汚損・破損・紛失された場合・丈つめなど加工をしている場合
                    <br>セール対象品
                    <br>タバコ、香水等の匂いが付いた商品
                    <br>お届け後、修理、クリーニング(洗濯)等された商品
                    <br>海外発送のご注文商品
                    <br>
                    <br>【 交換の場合 】
                    <br><b>サイズ交換は往復の送料をお客様にご負担していただいております。</b>
                    <br>交換カードを同封し、2日以内に元払いで当店までお送りくださいませ。
                    <br>商品が返送され次第、スタッフによる検品後の発送となります。
                    <br>状態によっては交換をお断りする場合もございますので、ご了承くださいませ。
                    <br>
                    <br>【 返品の場合 】
                    <br><b>ご返品は往復の送料をお客様にご負担していただいております。</b>
                    <br>返品カードを同封し、2日以内に元払いで当店までお送りくださいませ。
                    <br>商品が返送され次第、スタッフによる検品後のご返金となります。
                    <br>状態によっては返品をお断りする場合もございますので、ご了承くださいませ。
                    <br>返品・交換の際は、必ず下記のアドレスにてご連絡下さい。
                    <br>下記以外のメールアドレスからのご連絡には、多少お時間頂く場合がございます。
                    <br>
                    <br><a style="color: #0000FF" href="mailto:henpin-koukan@aun-wa.com">henpin-koukan@aun-wa.com</a>
                    <br>
                    <br>ご記入事項
                    <br>-----------------------------------------------------
                    <br>ご注文者様のお名前
                    <br>ご注文者様のお名前（フリガナ）
                    <br>受注番号
                    <br>ご注文時のお支払方法
                    <br>返品・交換をご希望の商品名
                    <br>返品・交換希望詳細
                    <br>-----------------------------------------------------
                    <br>以上の内容をメール本文にご明記ください。
                    <br>
                    <br>ご返信につきましては随時行わせていただきますが、2～3日お時間頂く場合もございます。
                    <br>
                    <br>商品は下記住所へお送りください。
                    <br>【 送り先 】
                    <br>〒121-0075 東京都足立区一ツ家2-3-3
                    <br>株式会社ロデオブロス宛
                    <br>連絡先：03-5856-5858
                    <br>責任者：三原秀晃
                    <br>
                    <br>【 ご返金について 】
                    <br>商品が当店に届き次第、返金手続きをさせていただきます。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">個人情報の利用目的について</h2>
                <p>【 利用目的 】</p>
                <p>当社は個人情報を以下の目的で利用させていただきます。</p>
                <br>
                <ol>
                    <li>お客様への商品の発送および代金の請求のためにお客様の氏名、住所、電話番号、e-mailアドレスなどの連絡先情報を利用します。<br>また、代金の請求および代金の支払いの確認に関連してご指定いただいた銀行口座などのお支払情報を利用する場合があります。</li>
                    <li>ご注文の内容や配送方法などを連絡したり確認するために、お客様の氏名、住所、電話番号、e-mailアドレスなどの連絡先情報やご注文いただいた商品の種類や数量、ご請求金額などの情報を利用します。</li>
                    <li>お客様に当社が行うキャンペーンやアンケート、商品・サービスのご案内をするために、ご利用履歴や、お客様の氏名、住所、電話番号、e-mailアドレスなどの連絡先情報などを利用します。</li>
                    <li>当社のサービス改善を行うために、お客様から寄せられたご意見やアンケートの結果、ご利用履歴などを利用します。</li>
                    <li>お客様からのご要望、お問い合わせに対する回答をするために、お客様の氏名、住所、電話番号、e-mailアドレスなどの連絡先情報を利用します。</li>
                    <li>不正な目的をもって商品を注文するような方にサービスのご利用をお断りするために、不正な目的での利用がなされたと判断したお取引に関するお客様の氏名、住所、ご注文いただいた商品の種類や数量、ご請求金額などの情報を利用します。</li>
                </ol>
                <br>
                <p>【 個人情報の管理について 】</p>
                <p>当社は以下の体制で個人情報を管理します。</p>
                <br>
                <ol>
                    <li>個人情報保護法やガイドラインに従って必要な社内体制を整備し、従業員から個人情報の取扱を適正に行う旨の誓約書を取得します。</li>
                    <li>個人情報の利用を業務上必要な社員だけに制限し、個人情報が含まれる媒体などの保管・管理などに関する規則を作り、個人情報保護のための予防措置を講じます。</li>
                    <li>システムに保存されている個人情報については、業務上必要な社員だけが利用できるようアカウントとパスワードを用意し、アクセス権限管理を実施します。なお、アカウントとパスワードは漏れ、滅失のないよう厳重に管理します。</li>
                    <li>サービスに支障が生じないことを前提として、個人情報の受領時から一定期間経過後、個人情報は随時削除していきます。</li>
                </ol>
                <br>
                <p>【 個人情報の開示について 】</p>
                <br>
                <ol>
                    <li>当社は、お客様の同意がない限り、個人情報を第三者に開示することはありません。ただし、以下の事例に該当する場合はその限りではありません。</li>
                    <ul>
                        <li>法令に基づき裁判所や警察等の公的機関から要請があった場合</li>
                        <li>法令に特別の規定がある場合</li>
                        <li>お客様や第三者の生命・身体・財産を損なうおそれがあり、本人の同意を得ることができない場合</li>
                        <li>法令や当社のご利用規約・注意事項に反する行動から、当社の権利、財産またはサービスを保護または防禦する必要があり、本人の同意を得ることができない場合</li>
                    </ul>
                    <li>お客様から当社の保有する個人情報に関し開示の請求を受けた場合は、ご本人からの請求であることが確認できた場合に限り開示します。</li>
                </ol>
            </div>

            <div class="row">
                <h2 class="h2">クーリングオフについて</h2>
                <p>クーリングオフは訪問販売や電話勧誘販売などに適用される制度です。
                <br>通信販売や店舗などで契約したものは購入する自らの意思をもって契約しているので、クーリングオフ制度は適用されません。
                <br>当店におきましてもお客様自らの意思を持ってご注文いただいておりますので、
                <br>予約商品など、あらかじめキャンセルや返品交換をご遠慮いただくよう記載がある商品につきましては、
                <br>いかなる理由でもご注文のキャンセル・返品交換は固くお断りさせていただきます。
                <br>何卒ご理解くださいますよう、お願い申し上げます。
                </p>
            </div>

            <div class="row">
                <h2 class="h2">海外への発送</h2>
                <p>海外への発送は、以下の配送方法にて承っております。
                    <br>・EMS
                    <br>・DHL
                    <br>ご希望の配送方法をご指定いただき、送付先情報を英語で記入下さい。
                    <br>ご指定がない場合は、DHLでの発送とさせて頂きます。
                    <br>
                    <br>送料につきましては、ご注文完了後、当店より別途メールにてご案内致します。
                    <br>日本の消費税は、非課税にしております。
                    <br>発送させていただく国に応じて、関税等がかかる場合がございます。
                    <br>また、発送は、入金確認後となります。
                    <br>
                    <br>We can ship your order outside of Japan.
                    <br>You can pick the shipping method from the following.
                    <br>
                    <br>・EMS(Express Mail Service)
                    <br>・DHL
                    <br>
                    <br>We recommend that you should pick DHL because they provide you first shipping and the tracking number. If you do not pick the shipping method, we ship your order by using DHL. As for shipping fee, we will send you e-mail to confirm shipping fee after you place your order. We will not chare you with any Japanese tax, but your contry may charge a certain tax. We ship your item after you make your payment. Please take a look at the shopping guide.
                </p>
            </div>

            <div class="information">
                <p>ご利用ガイドで解決しない問題は、お問い合わせください。
                    <br>一人一人のお客様に興味を持っていただき商品の良さをご理解していただきたいと思います。
                    <br>ご意見・お問い合わせ等ございましたら、メール・電話にてお願いします。
                    <br>
                    <br>電話番号：03-5856-5858
                    <br>
                    <a v-if="['R1', 'R2', 'O'].includes($store.state.hostName)" style="color:#000000" href="mailto:rodeo@aun-wa.com">rodeo@aun-wa.com</a>
                    <a v-else-if="['Y1', 'Y2'].includes($store.state.hostName)" style="color:#000000" href="mailto:rodeobros@aun-wa.com">rodeobros@aun-wa.com</a>
                    <br>
                    <br>定休日：日曜日・第3土曜日/夏季・年末年始休業
                    <br>電話対応時間：12:00 ～ 14:00
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'

export default {
  name: 'Company',

  components: { SectionTitle }
}
</script>

<style lang="scss" scoped>
a {
    text-decoration: underline;
    &:hover {
        opacity: 0.6;
    }
}

ul,
ol {
    margin-left: 1.5em;
}

ul {
    list-style: disc;
}

ol {
    list-style: decimal;
}

strong,
b {
    font-weight: 700;
}

hr {
    margin-top: 28px;
    margin-bottom: 28px;
    border: 0;
    border-top: 1px solid #dddddd;
}

.container {
    font-family: "Noto Sans JP", "游ゴシック体", "Yu Gothic", YuGothic, "ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "メイリオ", Meiryo, "MS Pゴシック", "MS PGothic", sans-serif;
    font-size: 16px;
    line-height: 1.75;
    letter-spacing: .05em;

    @media screen and (max-width: 722px) {
        font-size: 14px;
    }
}

.row + .row {
    padding-top: 64px;
}

.h2 {
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 700;
    border-bottom: 1px solid #222222;
}

.map {
    padding-top: 24px;
}

.information {
    padding: 64px;
    margin-top: 80px;
    background-color: #f7f8f7;

    @media screen and (max-width: 722px) {
        margin-top: 80px;
        padding: 40px 20px;
    }
}
</style>
